// JavaScript code for acf_blocks/testimonials-rotating-carousel component
(($) => {

    "use strict";
    if (!$('.acf-blocks-testimonials-rotating-carousel').length) {
        return;
    }
    const c = new CarouselEvo(document.querySelector('.acf-blocks-testimonials-rotating-carousel .testimonials-carousel-container'), {
        directionNav: true,
        buttonNav: 'none',
        autoplay: true,
        frontWidth: 395,
        frontHeight: 400,
        // Text-slide friendly tweaks:
        scaleDepth: true,     // keep card size constant
        hideEdgeSlides: false, // don't fully hide side slides
        backOpacity: 0.4,      // 40% opacity for background cards
        hMargin: 0.2,          // a little gap between slides
        vMargin: 0.0,          // keep vertical alignment tight
        speed: 450,
        backZoom: 0.85,        // ignored when scaleDepth=false, but fine to leave
        gap: 0.7,
        circularMode: true,
        circularVisible: 1,
    });

})(jQuery);